<template>
  <div>
    <a-form :form="editForm" @submit="handleSubmit" autocomplete="off" class="ant-advanced-search-form">
      <a-row :gutter="10">
        <!-- 选房间类型 -->
        <a-col :xs="24" :lg="3">
          <a-form-item
            label="RM Pref."
          >
            <a-select
              v-decorator="[
                'roomPreferred',
                {rules: [{ required: false, message: 'Please select roomPreferred' }]}
              ]"
              :showArrow="true"
            >
              <!-- <a-select-option value="">N/A</a-select-option> -->
              <a-select-option value="1">TWN</a-select-option>
              <a-select-option value="2">DBL</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 餐食 -->
        <a-col :xs="24" :lg="6">
          <a-form-item
            label="Meals Restrictions"
          >
            <a-select
              mode="multiple"
              @change="handleMealsRequestChange"
              v-decorator="[
                'mealsRequest',
                {rules: [{ required: false, message: 'Please select Meals Request' }]}
              ]"
              :showArrow="true"
            >
              <a-select-option v-for="i in mealsList" :key="'mealsRequest-' + i.code" :value="i.code" :disabled="i.disabled">
                <span>
                  <span>{{ i.enName }}</span>
                  <span v-if="i.twName && i.twName !== ''">/{{ i.twName }}</span>
                </span>
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 要求 -->
        <a-col :xs="24" :lg="6">
          <a-form-item
            label="Special Requests"
          >
            <a-select
              mode="multiple"
              @change="handleSpecialRequestChange"
              v-decorator="[
                'specialRequest',
                {rules: [{ required: false, message: 'Please select Special Request' }]}
              ]"
              :showArrow="true"
            >
              <a-select-option v-for="i in specialList" :key="'mealsRequest-' + i.code" :value="i.code" :disabled="i.disabled">
                <span>
                  <span>{{ i.enName }}</span>
                  <span v-if="i.twName && i.twName !== ''">/{{ i.twName }}</span>
                </span>
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :lg="9">
          <a-form-item
            label="Internal note"
          >
            <a-textarea
              v-decorator="[
                'specialNote',
                {rules: [{ required: false, message: 'Please input your Special Note' }]}
              ]"
              placeholder="Please input your Special Note!"
              auto-size
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div>
      <tour-records v-if="editData && editData.id" :customerId="editData.id" :record="record" @change="handleTourInfoChange"></tour-records>
    </div>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import TourRecords from './tourRecord/CdbCustomerTourRecordList'
import { Meals, Special } from '@/utils/helper/dict-cdb-utils'

export default {
  name: 'CdbCustomerTour',
  components: {
    TourRecords
  },
  props: {
    tourData: {
      type: [Object],
      default: null,
    },
    record: {
      type: [String, Object],
      default: null
    }
  },
  data () {
    return {
      editForm: this.$form.createForm(this),
      editData: this.tourData,
      mealsList: null,
      specialList: null,
      roomList: null,
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    // 初始化数据
    async loadData() {
      if (this.editData) {
        this.mealsList = await Meals.getDict()
        this.specialList = await Special.getDict()
        const vueData = this.copyDataByJSON(this.editData)
        const editData = pick(vueData, ['mealsRequest', 'specialRequest', 'specialNote','roomPreferred' ])
        // 餐食需求
        if (editData.mealsRequest && editData.mealsRequest !== '') {
          editData.mealsRequest = editData.mealsRequest.split(',')
          editData.mealsRequest = editData.mealsRequest.slice(0, editData.mealsRequest.length - 1)
        } else {
          editData.mealsRequest = []
        }
        // 特别需求
        if (editData.specialRequest && editData.specialRequest !== '') {
          editData.specialRequest = editData.specialRequest.split(',')
          editData.specialRequest = editData.specialRequest.slice(0, editData.specialRequest.length - 1)
        } else {
          editData.specialRequest = []
        }
        this.$nextTick(() => {
          this.editForm.setFieldsValue(editData)
          this.handleMealsRequestChange(editData.mealsRequest)
          this.handleSpecialRequestChange(editData.specialRequest)
        })
      }
    },
    // Meals 限制
    handleMealsRequestChange (newValue) {
      const mealsList = this.mealsList
      if (mealsList && mealsList.length > 0) {
        mealsList.forEach(i => {
          i.disabled = false
          if (newValue && newValue.length > 0) {
            if (newValue.includes('0') && i.code !== '0') {
                  i.disabled = true
                }
                if (!newValue.includes('0') && i.code === '0') {
                  i.disabled = true
                }
          }
          })
      }
    },
    // Special 限制
    handleSpecialRequestChange (values) {
      const specialList = this.specialList
      if (specialList && specialList.length > 0) {
        specialList.forEach(i => {
          i.disabled = false
          if (values && values.length > 0) {
            if (values.includes('0') && i.code !== '0') {
                i.disabled = true
              }
              if (!values.includes('0') && i.code === '0') {
                i.disabled = true
              }
           }
        })
      }
    },
    handleSubmit (e) {
      e.preventDefault()
    },
    // 父组件调用校验方法
    validateTourForm () {
      const that = this
      const editForm = that.editForm
      return new Promise((resolve, reject) => {
        editForm.validateFields((err) => {
          if (err) {
            reject()
            return
          }
          var formData = editForm.getFieldsValue()
          // 餐食需求
          if (formData.mealsRequest && formData.mealsRequest.length > 0) {
            formData.mealsRequest = formData.mealsRequest.join(',')
            formData.mealsRequest = formData.mealsRequest + ','
          } else {
            formData.mealsRequest = null
          }
          // 特别需求
          if (formData.specialRequest && formData.specialRequest.length > 0) {
            formData.specialRequest = formData.specialRequest.join(',')
            formData.specialRequest = formData.specialRequest + ','
          } else {
            formData.specialRequest = null
          }
          resolve(formData)
          return
        })
      })
    },
    // 处理TourInfo变化
    handleTourInfoChange () {
      this.$emit('change')
    }
  },
  watch: {
    tourData() {
      this.loadData()
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .ant-col .ant-form-item-label {
   font-weight: 600;
}
</style>
